import { IntlShape } from 'react-intl';

import { calcDateTime, diffDateTime } from '@ocx/utils-date';

import { offerMessages } from './offer.messages';

export type GetOfferExpirationDaysOptions = {
  /** number of days when voucher expires */
  voucherExpiresAt: number | null;
  /** date string of offer expiration */
  offerExpiresAt: string | null;
};

export type VoucherExpiresIn = {
  value: number;
  unit: 'days' | 'hours' | 'minutes';
};

export const getVoucherExpiresIn = (options: GetOfferExpirationDaysOptions): VoucherExpiresIn | null => {
  const { voucherExpiresAt, offerExpiresAt } = options;
  if (voucherExpiresAt && offerExpiresAt) {
    const now = new Date();
    const offerExpiresAtDate = new Date(offerExpiresAt);
    const voucherExpiresAtDate = calcDateTime(now, 'add', voucherExpiresAt, 'day');
    const minExpirationDate = new Date(Math.min(voucherExpiresAtDate.valueOf(), offerExpiresAtDate.valueOf()));

    const diffMinutes = Math.abs(diffDateTime(now, minExpirationDate, 'minute'));
    if (diffMinutes < 60) {
      return { value: diffMinutes, unit: 'minutes' };
    }
    const diffHours = Math.abs(diffDateTime(now, minExpirationDate, 'hour'));
    if (diffHours < 24) {
      return { value: diffHours, unit: 'hours' };
    }
    const diffDays = Math.abs(diffDateTime(now, minExpirationDate, 'day'));
    return { value: diffDays, unit: 'days' };
  }
  if (voucherExpiresAt) {
    return { value: voucherExpiresAt, unit: 'days' };
  }
  return null;
};

export const getVoucherExpiresInMessage = (expiresIn: VoucherExpiresIn, intl: IntlShape): string => {
  if (expiresIn.unit === 'minutes' && expiresIn.value < 30) {
    return intl.formatMessage(offerMessages.expiresLessThanHour);
  }
  if (expiresIn.unit === 'minutes' || (expiresIn.unit === 'hours' && expiresIn.value === 1)) {
    return intl.formatMessage(offerMessages.expiresAnHour);
  }
  if (expiresIn.unit === 'hours') {
    return intl.formatMessage(offerMessages.expiresHours, { expiresIn: expiresIn.value });
  }
  return intl.formatMessage(offerMessages.expiresDays, { expiresIn: expiresIn.value });
};
